import React from 'react'
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'

import Index from 'views/Index'
import MuralPage from 'views/pages/MuralPage'
import TermosPage from 'views/pages/TermosPage'
import ConsultaPage from 'views/pages/ConsultaPage'
import AgradecePage from 'views/pages/AgradecePage'
import RecuperaSenhaPage from 'views/pages/RecuperaSenhaPage'
import RedefinirSenhaPage from 'views/pages/RedefinirSenhaPage'
import MeuPerfilPage from 'views/pages/MeuPerfilPage'
import PesquisaIndividualPage from 'views/pages/PesquisaIndividualPage'
import PesquisaMassaPage from 'views/pages/PesquisaMassaPage'
import LoginPage from 'views/pages/LoginPage'
import Sair from 'views/pages/Sair'
import ListaAprovadosPage from 'views/pages/ListaAprovadosPage'
import ConsolidadoPage from 'views/pages/ConsolidadoPage'
import { isAuthenticated } from 'services/auth'
import ConsolidadoFiltroPage from 'views/pages/ConsolidadoFiltroPage'
import Politicas from 'views/pages/Politicas'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
)

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/politica-de-privacidade" component={Politicas} />
        <Route exact path="/termos-de-uso" component={TermosPage} />

        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/esqueci-minha-senha" component={RecuperaSenhaPage} />
        <Route exact path="/redefinir-senha/:guid" component={RedefinirSenhaPage} />
        <Route exact path="/consulta-aprovados-sisu/:name" component={ConsultaPage} />

        <PrivateRoute exact path="/sair" component={Sair} />

        <PrivateRoute exact path="/meu-perfil" component={MeuPerfilPage} />
        <PrivateRoute exact path="/pesquisa-individual-sisu" component={PesquisaIndividualPage} />
        <PrivateRoute exact path="/pesquisa-em-massa-sisu" component={PesquisaMassaPage} />
        <PrivateRoute exact path="/lista-aprovados" component={ListaAprovadosPage} />
        <PrivateRoute exact path="/cadastro-aprovados-sisu" component={AgradecePage} />
        <PrivateRoute exact path="/resultados-consolidados" component={ConsolidadoPage} />
        <PrivateRoute exact path="/resultados-consolidados-filtro" component={ConsolidadoFiltroPage} />
        <PrivateRoute exact path="/mural-aprovados-sisu" component={MuralPage} />

        <Redirect path="*" to="/" exact />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
